import React from 'react'
import "./Education.css"
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaGraduationCap } from "react-icons/fa";

function Education() {

    const data = [
        {
            name: "JUST University",
            degreeName: "B.sc in Software Engineering",
            year: "2019-2023",
            des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",

        },

        {
            name: "Al-Hilaal School",
            degreeName: "High School certificate",
            year: "2018-2019",
            des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",

        }
    ]

    const colors = [
        "#FFA233",
        "#336BFF",
        "#FF1043",
        "#33FFDD",
        "#8DFF33",
    
      ]


    return (
        <div id='education' className='container education-section'>
            <div className="section-titel">
                <h5>Education</h5>
                <span className='line1'></span>
            </div>

            <div className="timeline-section">
        <div className="edu">
          <VerticalTimeline lineColor='#FF1043'>

            {data.map((item, index) => (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: colors[index], color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid   #000' }}
                date={item.year}
                dateClassName="data-class"
                iconStyle={{ background: colors[index], color: '#fff' }}
                icon={<FaGraduationCap />}
              >
                <h3 className="vertical-timeline-element-title">{item.name}</h3>
                <h5 className="vertical-timeline-element-subtitle" style={{color:"black"}}>{item.degreeName}</h5>

                

                <p>
                  {item.des}
                </p>
              </VerticalTimelineElement>
            ))}





          </VerticalTimeline>
        </div>
      </div>

        </div>
    )
}

export default Education